export const memo = <K, V>(fn: (key: K) => V, cache = new Map<K, V>()) => {
  return (key: K): V => {
    const hit = cache.get(key);
    if (hit !== undefined) return hit;
    const value = fn(key);
    cache.set(key, value);
    return value;
  };
};
